import { branding, Colour_Tournament } from "./Utils";

export class Substitution {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Substitution";
    this.scene = "Substitution";
    this.data = [];
    this.page = 7070;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      xml = branding({ game: options.game, team: options.team, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0000";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "101";
      }).value = options.players?.[0]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = options.players?.[0]?.squad?.player?.first_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = options.players?.[0]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "108";
      }).value = "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "121";
      }).value = options.players?.[1]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "122";
      }).value = options.players?.[1]?.squad?.player?.first_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "123";
      }).value = options.players?.[1]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value = "";

      xml.payload.field.find((item) => {
        return item.attr.name === "300.active";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = options.hia || options.reversal ? "HIA" : "Interchange";

      xml.payload.field.find((item) => {
        return item.attr.name === "301";
      }).value = options.hia
        ? "sub"
        : options.reversal
          ? "reversal"
          : parseInt(options.made + 1) + "/" + options.total;

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }

  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
